import { Button } from '../../Utility/Button';
import AdminContainer from '../../Utility/AdminContainer';
import useBilling from '../../../Hooks/useBilling';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import LoadingSpinner from '../../Utility/LoadingSpinner';
import { Booking } from '../../../Types';

function Billing() {
    const { bookings, userSettings, i18n, bookingsLoaded, getBreakpoint, windowWidth, handleNavigate } = useBilling();
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(130px,200px),minmax(130px,200px),minmax(211px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    {userSettings.isAvency && (
                        <div className="mb-4 md:hidden">
                            <Button className="!m-0 w-full" onClick={() => handleNavigate('addcredit')}>
                                {i18n.translate({ id: 'prepaidButton.new', sourceName: 'Billing' })}
                            </Button>
                        </div>
                    )}
                    <div className="hidden md:block">
                        <AdminViewHeader
                            gridCols={GRID_COLS}
                            cols={{
                                cols: [
                                    {
                                        text: i18n.translate({ id: 'bookings.date', sourceName: 'Billing' }),
                                    },
                                    {
                                        text: i18n.translate({ id: 'bookings.title', sourceName: 'Billing' }),
                                    },
                                    {
                                        text: i18n.translate({ id: 'bookings.amount', sourceName: 'Billing' }),
                                    },
                                ],
                                button: {
                                    text: i18n.translate({ id: 'prepaidButton.new', sourceName: 'Billing' }),
                                    function: () => handleNavigate('addcredit'),
                                },
                            }}
                        />

                        <hr className="border-layout-borderColor mt-5" />
                    </div>

                    {bookingsLoaded ? (
                        bookings.length > 0 ? (
                            bookings.map((booking: Booking, index: number) => (
                                <AdminViewContent
                                    key={booking.identifier}
                                    mobile={windowWidth < getBreakpoint('md')}
                                    identifier={booking.identifier}
                                    useSmallFontMobile={true}
                                    gridCols={GRID_COLS}
                                    cols={{
                                        optionalCols: [
                                            {
                                                content: booking.date.toLocaleString(),
                                            },
                                            {
                                                content: booking.title,
                                            },
                                            {
                                                content: booking.amount,
                                            },
                                        ],
                                        mobileOrder: {
                                            main: booking.title,
                                            optionalCols: [booking.amount, booking.date.toLocaleString()],
                                        },
                                    }}
                                />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col justify-center  items-center h-10 pt-2">
                                <span className="text-center">
                                    {i18n.translate({ id: 'noBookings', sourceName: 'Billing' })}
                                </span>
                            </div>
                        )
                    ) : (
                        <div className="flex justify-center">
                            <LoadingSpinner />
                        </div>
                    )}
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Billing;
